import React from "react";

export default function FloatingContact({ phone = "+84901234567" }) {
  const rawNumber = phone.replace(/[\s+\-()]/g, "");
  const zaloLink = `https://zalo.me/${rawNumber.replace(/^0/, "84")}`;

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col gap-3 items-end">
      <a
        href={zaloLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat Zalo"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white shadow-lg hover:scale-105 transition"
        title="Chat Zalo"
      >
        {/* Zalo SVG icon (white Z-like stroke) */}
        <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M6 8h12v2L10 17H16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>

      <a
        href={`tel:${rawNumber}`}
        aria-label="Gọi ngay"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 text-white shadow-lg hover:scale-105 transition"
        title="Gọi ngay"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M2.003 5.884l2-3A1 1 0 015 2h3a1 1 0 011 1v3a1 1 0 01-.293.707L7.414 8.414a12.042 12.042 0 005.172 5.172l1.707-1.293A1 1 0 0115 12h3a1 1 0 011 1v3a1 1 0 01-0.884.993l-3 .5A17 17 0 012 5.884z" />
        </svg>
      </a>
    </div>
  );
}
